// angular
// 	.module("HeroPRO")
// 	.controller("HideJobController", hideJobController);

import _ from 'lodash';
import './hideJob.scss';

/* @ngInject */
export default function hideJobController($rootScope, JobFactory, UserData, raSpinnerService, ModalService, $analytics) {
    const vm = this;

    vm.selectedReason = {};
    vm.otherReason = '';
    vm.reasons = [];
    vm.isHideDisabled = false;
    vm.activeJob = {};

    vm.defaultReason = {
        Name: 'Choose One',
        Reason: 'Choose One',
        ContractorJobHideReasonTypeId: -1,
    };

    init();

    /*= =======================================
	 =            Public Functions            =
	 ======================================== */

    vm.reasonClicked = function (item) {
        vm.selectedReason = item;
        vm.isHideDisabled = isButtonDisabled();
        vm.hideJobForm.$setPristine();
    };

    vm.hideProject = function (isValid) {
        if (isValid) {
            let params = {};
            if (vm.activeJob.PreQualId !== undefined && vm.activeJob.PreQualId !== null && vm.activeJob.PreQualId !== '') {
                params = {
                    PreQualId: vm.activeJob.PreQualId,
                    ContractorJobHideReasonTypeId: vm.selectedReason.ContractorJobHideReasonTypeId,
                    Reason: (vm.otherReason === '' ? vm.selectedReason.Reason : vm.otherReason.trim()),
                };
                JobFactory.hideLead(params).then(() => {
                    $rootScope.$broadcast('pipelineHideJob', {
                        data: {
                            PreQualId: vm.activeJob.PreQualId,
                            Address: `${vm.activeJob.Address.trim().toLocaleUpperCase()}, ${vm.activeJob.City.toLocaleUpperCase()}`,
                        },
                    });
                    ModalService.closeLgModal();
                });
            } else {
                params = {
                    FundingRequestId: vm.activeJob.FundingRequestId,
                    ContractorJobHideReasonTypeId: vm.selectedReason.ContractorJobHideReasonTypeId,
                    Reason: (vm.otherReason === '' ? vm.selectedReason.Reason : vm.otherReason.trim()),
                };
                JobFactory.hideApplication(params).then(() => {
                    $rootScope.$broadcast('pipelineHideJob', {
                        data: {
                            FundingRequestId: vm.activeJob.FundingRequestId,
                            Address: `${vm.activeJob.PropertyAddress1} ${vm.activeJob.PropertyCity}, ${vm.activeJob.PropertyState} ${vm.activeJob.PropertyZip}`,
                        },
                    });
                    ModalService.closeLgModal();
                });
            }

            $analytics.eventTrack('Hide Job Clicked', { category: 'HideAJob', label: (vm.otherReason === '') ? vm.selectedReason.Reason : vm.otherReason.trim() });
        }
    };

    vm.cancelHide = function () {
        ModalService.closeLgModal();
    };

    /* -----  End of Public Functions  ------*/

    /*= =======================================
	 =            Private Functions            =
	 ======================================== */
    function init() {
        getReasons();
        vm.activeJob = JobFactory.getActiveJob();
    }

    function getReasons() {
        JobFactory.getHideReasons().then((response) => {
            vm.reasons = response.data.Data;
            if (_.findWhere(vm.reasons, { ContractorJobHideReasonTypeId: -1 }) === undefined) {
                _.each(vm.reasons, (reason) => {
                    if (reason.Name === 'Other') {
                        reason.Reason = 'Other';
                    }
                });
                vm.reasons.unshift(vm.defaultReason);
                vm.selectedReason = vm.reasons[0];
                vm.isHideDisabled = isButtonDisabled();
            }
        });
    }

    function isButtonDisabled() {
        return vm.selectedReason.ContractorJobHideReasonTypeId === -1;
    }
}




// WEBPACK FOOTER //
// ./src/app/common/job/hide/hideJobController.js